import React from 'react';

export default function EconomyStatus({ economyEffects, containerStyle = {} }) {
  const getTileTypeIcon = (tileType) => {
    const iconMap = {
      3: '🌾', 4: '🏪', 5: '⛏️', 6: '🐟', 7: '⚓', 8: '🛢️', 9: '🕳️',
      10: '🏗️', 11: '⚡', 12: '🏭', 14: '🏢'
    };
    return iconMap[tileType] || '📍';
  };

  const getTileTypeName = (tileType) => {
    const nameMap = {
      3: 'Farm', 4: 'Market', 5: 'Mine', 6: 'Fishery', 7: 'Port',
      8: 'Oil Rig', 9: 'Oil Well', 10: 'Lumber Mill', 11: 'Power Plant',
      12: 'Factory', 14: 'Construction Company'
    };
    return nameMap[tileType] || 'Unknown';
  };

  const getEffectColor = (percentage) => {
    return percentage > 0 ? '#4CAF50' : '#FF5722';
  };

  const getEffectSign = (percentage) => {
    if (percentage > 0) return '+';
    if (percentage < 0) return '−'; // proper minus sign
    return '';
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: '300px',
        left: '10px',
        color: 'white',
        fontFamily: 'Arial, sans-serif',
        width: '290px',
        padding: '10px',
        borderRadius: '5px',
        ...containerStyle
      }}
    >
      <div
        style={{
          fontSize: '1em',
          maxHeight: '180px',
          overflowY: 'auto',
          marginLeft: '10px'
        }}
      >
        {economyEffects.map((effect) => (
          <div
            key={effect.id}
            style={{
              marginBottom: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <span style={{ fontSize: '1.2em' }}>
              {getTileTypeIcon(effect.tileType)}
            </span>
            <span style={{ fontWeight: 'bold', color: '#FFD700' }}>
              {getTileTypeName(effect.tileType)}
            </span>
            <span
              style={{
                fontWeight: 900,
                color: getEffectColor(effect.effectPercentage),
                fontSize: '1em'
              }}
            >
              {getEffectSign(effect.effectPercentage)}
              {Math.abs(effect.effectPercentage).toFixed(0)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}